<template>
  <img
    :src="img"
    @error="handleImageError"
    alt="" />
</template>

<script>
export default {
  props: {
    imageSrc: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      img: ''
    }
  },
  watch: {
    imageSrc (data) {
      if (data) {
        this.handleImage()
      }
    }
  },
  mounted () {
    this.handleImage()
  },
  methods: {
    handleImageError () {
      // this.$el.style = 'display:none;'
      // this.$el.remove(1)
    },
    handleImage () {
      try {
        this.img = require(`@/assets/img/providers/${this.imageSrc}.png`)
        this.$el.style = 'display:inline-block;'
      } catch (e) {
        this.img = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='
        this.$el.style = 'display:none;'
      }
    }
  }
}
</script>
